export interface IDrillThruRowData {
    rowObject?: any
    vuId?: number
    mdsColumnData?: any
    formedColumn?: any
    tableHeading?: string[]
    JSONRowDataLists?: {
        sortColumnsData?: any[]
        jsonRowEncrypyedList?: any[]
        jsonRowList?: any[]
        featureList?: any[]
    }
    launcherMode?:any
    valText?: string
    headerText?: string
    colCounter?: number
    rowCounter?: number
    drillThruVUObj?: any
    data_drillThruSearchObj?: any
    data_isEnabledAutoNavigation?: string | boolean
    set_drillThruComponentType?: DrillThruComponentType
    data_is_summary?:boolean
    LinkSetUpCallBack?:any
    firstColumnWidth?:number
    cellRef?:any
}

export enum DrillThruComponentType {
    DrillThruTableRow = 'DrillThruTableRow',
    HighlightDrillThru = 'HighlightDrillThru'
}

export interface ImdsColumnKeys {
    javascriptTarget: string
    hideInDrillThru: 'True' | 'False'
    EncryptforMDSCId: string
    MDSColumnId: string
    OCVId: string
    AllowedPrivileges: string | null
    EmptyColor: string
    MetadataId: string
    DisplayTruncateColumn: string
    dataType: string
    columnName: string
    javascriptTargetParams: string
}

export interface ILinkProps {
    id: string;
    title: string;
    href: string;
    onContextMenu?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    style: React.CSSProperties;
    onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export interface LinkResult {
    LinkValues: ILinkProps;
    IsLink: boolean;
}